import React from 'react';

import { Wrapper, HeaderWrapper, Header, TextWrapper, Text } from './elements';

type Props = {
  readonly className?: string;
  readonly title: string;
  readonly time: number | string;
  readonly notificationText: string;
};

export default function EngagerSent(props: Props): React.ReactElement {
  return (
    <Wrapper className={props.className}>
      <HeaderWrapper>
        <Header
          leftIcon={'icon-notifications_none'}
          title={props.title}
          time={props.time}
        />
      </HeaderWrapper>
      <TextWrapper>
        <Text>{props.notificationText}</Text>
      </TextWrapper>
    </Wrapper>
  );
}
